import {Button, Tooltip} from "antd";
import {PlusCircleFilled} from "@ant-design/icons";

type AddVariantOptionButtonProps = {
  lengthOfFields: number;
  handleAddVariantOption(): void;
};

export function AddVariantOptionButton({
  handleAddVariantOption,
  lengthOfFields,
}: AddVariantOptionButtonProps) {
  return (
    <div>
      <Tooltip title={lengthOfFields > 4 ? "You can only add 5 variants" : null}>
        <Button
          disabled={lengthOfFields > 4}
          onClick={handleAddVariantOption}
          icon={<PlusCircleFilled />}
          size="small"
          type="text"
        >
          Add an option
        </Button>
      </Tooltip>
    </div>
  );
}
